<template>
  <div class="spell">
    <img loading="lazy" sizes="100%, 100%" class="spell-icon" :src="spell.image" :alt="spell.name" :title="spell.name">
  </div>
</template>

<script>
  export default {
    name: "Spell",
    props: {
      spell: {
        type: Object,
        required: true
      }
    },
    methods: {}
  }
</script>

<style scoped>
  .spell {
    cursor: pointer;
  }

  .spell-icon {
    transform: scale(2.0);
  }
</style>



// WEBPACK FOOTER //
// src/components/gear-selector/Spell.vue